import { Injectable, EventEmitter } from '@angular/core';
import { environment } from '../../../../environments/environment';

// Enums
import { MessageTypeEnum } from '../../enums';

// Interfaces
import { IService, IMessage, IError } from '../../interfaces';

@Injectable()
export class MessageService implements IService {
	// implements local variables
	public showLocalMessage$ =
		new EventEmitter<{ name: string, message: { message: string, isError: boolean, type: MessageTypeEnum } }>(false);
	public showTopError$ = new EventEmitter<{ message: string, isError: boolean, type: MessageTypeEnum }>(false);
	public showBottomError$ = new EventEmitter<{ message: string, isError: boolean, type: MessageTypeEnum }>(false);
	public clearError$ = new EventEmitter(true);
	private _ERROR_MESSAGE: IMessage;

	// implements IService
	name = 'MessageService';
	test(name, value) {
		console.log('testing', name, value);
	}
	constructor() { }

	DisplayTopError(message: string, isError: boolean, type: MessageTypeEnum) {
		return this.DisplayError(message, isError, type, { top: true, bottom: false });
	}

	DisplayBottomError(message: string, isError: boolean, type: MessageTypeEnum) {
		return this.DisplayError(message, isError, type, { top: false, bottom: true });
	}

	DisplayBothError(message: string, isError: boolean, type: MessageTypeEnum) {
		return this.DisplayError(message, isError, type, { top: true, bottom: true });
	}

	DisplayError(
		message: string,
		isError: boolean,
		MessageType: MessageTypeEnum,
		location?: { top: boolean, bottom: boolean }): Promise<string> {
		return new Promise((resolve, reject) => {
			console.log('ERROR', message);
			if (location) {
				if (location.bottom) {
					this.showBottomError$.emit({ message: message, isError: isError, type: MessageType });
				}
				if (location.top) {
					this.showTopError$.emit({ message: message, isError: isError, type: MessageType });
				}
			} else {
				this.showBottomError$.emit({ message: message, isError: isError, type: MessageType });
				this.showTopError$.emit({ message: message, isError: isError, type: MessageType });
			}
			resolve(message);
		});
	}

	DisplayLocalMessage(
		name: string,
		message: {
			message: string,
			isError: boolean,
			type: MessageTypeEnum
		}
	) {
		'DisplayLocalMessage'.logWithObject(this.name, [name, message]);
		this.showLocalMessage$.emit({ name: name, message: message });
	}

	Clear() {
		this.clearError$.emit();
	}

	set ERROR_MESSAGE(value: IMessage) {
		this._ERROR_MESSAGE = value;
	}

	get ERROR_MESSAGE() {
		return this._ERROR_MESSAGE;
	}

	ServerLog(isError: boolean, e: IError) {
		const type = isError ? 'error' : 'message';
		const endPoint = `${environment.APILocation}nLog${type}`;
		// return this._sessionService.Post(endPoint, e)
		// .map(res => res.json())
		//  .do(data => {
		//     'error has been logged at the server level'.logWithObject(this.name, [data, e]);
		//   })
		//   .retry(2)
		//   .catch(this.handleError);
	}

	private handleError(error: Response | any) {
		// In a real world app, we might use a remote logging infrastructure
		let errMsg: string;
		if (error instanceof Response) {
			const body = error.json();
			body.then(content => {
				const err = content.error || JSON.stringify(body);
				errMsg = `Response ${error.status} - ${error.statusText || ''} ${err}`;
			}, fail => {
				errMsg = 'Body failed' + fail;
			});
		} else {
			errMsg = 'Not a response' + error.message ? error.message : error.toString();
		}
		'An error message has been returned'.ErrorWithObject(
			'ServerLog', errMsg);
		return Promise.reject(errMsg);
	}

}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/message/message.service.ts